module.exports = __webpack_public_path__ + "img/gold_inte@2x.49b935be.png";